import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import firebase from "firebase";
import VueTextareaAutosize from "vue-textarea-autosize";

Vue.use(VueTextareaAutosize);

Vue.config.productionTip = false;

firebase.initializeApp({
  apiKey: "AIzaSyDWFkeAS7xEI-FebI0VbESAuJl6NX17XR4",
  authDomain: "filatori-beff0.firebaseapp.com",
  databaseURL: "https:/filatori-beff0.firebaseio.com",
  projectId: "filatori-beff0",
  storageBucket: "filatori-beff0.appspot.com",
  messagingSenderId: "123784763742",
  appId: "1:123784763742:web:45260608af7dbb776ed7cf",
  measurementId: "G-7R7LDZRQRD",
});

export const db = firebase.firestore();

new Vue({
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
